// extracted by mini-css-extract-plugin
module.exports = {"layout":"LayoutContainer_layout__rlsyg","standard":"LayoutContainer_standard__NcF7d","fullwidth":"LayoutContainer_fullwidth__uzvow","bg":"LayoutContainer_bg__qe33J"};